import SentRequestsTable from './SentRequestsTable'

export default SentRequestsTable
